import styled from "styled-components/native";

import { TextInput } from "components";
import {
  pickStyle as _,
  pickThemeKey as theme,
  flexStart,
  flexEnd,
} from "utils";
import {
  ContainerWidth,
  ContainerHeight,
  ContainerMarginBottom,
  InputPadding,
  DropDownPadding,
} from "./variables";

export const Container = styled.View`
  margin: 0 auto ${_(ContainerMarginBottom) || 50}px;
  position: relative;
  width: ${_(ContainerWidth) || "100%"};
  z-index: 1;
  min-height: ${({ isOpen }) => (isOpen ? _(ContainerHeight) : 0)};
`;

export const LabelWrapper = styled.TouchableOpacity``;

export const Label = styled.Text`
  color: ${props =>
    props.$isFocused
      ? theme("themeBlack")(props)
      : theme("themeLightGrey")(props)};
  position: absolute;
  font-size: ${props => (props.$isFocused ? 13 : 18)}px;
  position: absolute;
  top: ${props => (props.$isFocused ? 1 : 18)}px;
  ${flexStart()}: 18px;
  z-index: 2;
`;

export const CarrotImage = styled.Image`
  position: absolute;
  ${flexEnd()}: 14px;
  top: 50%;
  margin-top: -3px;
  height: 6px;
  width: 11px;
`;

export const StyledTextInput = styled(TextInput)`
  padding: ${_(InputPadding) || " 20px 18px 15px"};
  background-color: ${theme("open_ended_background")};
  border-radius: 3px;
  width: 100%;
  border-bottom-width: 5px;
  border-bottom-color: ${props =>
    props.$isFocused
      ? theme("open_ended_borders")(props)
      : theme("themeLightGrey")(props)};
  font-size: ${theme("other_text_size") || 18}px;
  color: ${theme("open_ended_text")};
`;

export const Wrapper = styled.TouchableOpacity`
  left: 0;
  right: 0;
  width: 100%;
  background-color: ${theme("open_ended_background")};
  text-align: center;
  border-radius: 5px;
  height: 100px;
  overflow-y: scroll;
`;

export const OptionList = styled.TouchableOpacity`
  padding: ${_(DropDownPadding) || "8"}px 0px;
  background-color: ${props =>
    props.$isSelected
      ? theme("selected_option_background")(props)
      : theme("open_ended_background")(props)};
`;

export const Option = styled.Text`
  font-size: ${theme("other_text_size") || 18}px;
  text-align: center;
  color: ${props =>
    props.$isSelected
      ? theme("open_ended_background")(props)
      : theme("themeLightBlack")(props)};
`;
